import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import useStyles from "./ButtonChoice.styles";
import { RadioIcon } from "./RadioIcon";
import { CheckBoxIcon } from "./CheckBoxIcon";
import { useMouseHover } from "../../hooks/useMouseHover";

interface Props {
    id?: string;
    type: "checkbox" | "radio";
    label?: string;
    className?: string;
    disabled?: boolean;
    selected?: boolean;
    hasOpenEnd?: boolean;
    openEndSize?: string;
    horizontal?: boolean;
    onSelect?(): void;
    onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
    renderChoice?(): any;
    renderAfter?(): any;
    carrouselChoiceBackgound?: string;
}

export function ButtonChoice(props: Props) {
    const {
        id,
        disabled,
        label,
        type,
        className,
        hasOpenEnd,
        openEndSize,
        horizontal,
        selected,
        onSelect,
        onKeyDown,
        renderChoice,
        renderAfter,
        carrouselChoiceBackgound,
    } = props;

    const [hover, pointerHandlers] = useMouseHover();
    const [active, setActive] = React.useState(false);

    const theme = useTheme() as any;
    const classes = useStyles({
        theme,
        selected,
        hasOpenEnd,
        openEndSize,
        horizontal,
        type,
        carrouselChoiceBackgound,
    });

    const ChoiceIcon = type === "radio" ? RadioIcon : CheckBoxIcon;

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            id={id}
            role={type}
            aria-checked={selected}
            aria-label={label}
            tabIndex={0}
            onFocus={() => setActive(true)}
            onBlur={() => setActive(false)}
            {...pointerHandlers}
            onKeyDown={onKeyDown}
            onMouseDown={(e) => {
                const div = e.target as HTMLDivElement;
                const activeElement = document.activeElement as HTMLElement;
                if (!div.contains(activeElement)) activeElement.blur();
                e.preventDefault();
            }}
            onClick={() => onSelect()}
            className={classnames(
                classes.choice,
                ...([className] || []),
                hover && classes.choiceHover,
                active && classes.choiceActive,
                selected && classes.choiceSelected,
            )}
        >
            <div className={classes.choiceContainer}>
                {renderChoice ? (
                    renderChoice()
                ) : (
                    <>
                        <ChoiceIcon checked={selected} disabled={disabled} hover={hover} />
                        {theme.DisplayChoiceIcon !== "none" && <span className={classes.spacer} />}
                        <span
                            className={classes.choiceText}
                            id={id}
                            dangerouslySetInnerHTML={{ __html: label }}
                        />
                    </>
                )}
            </div>
            {renderAfter && renderAfter()}
        </div>
    );
}
